import React, {
  useState,
  useCallback,
  useRef,
  useEffect,
  useMemo,
} from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { useSnackbar } from "notistack";

import { StepOneComponent, StepTwoComponent, StepFiveComponent } from ".";
import styles from "./styles.module.scss";
import { Button, BtnType } from "../../primitives";
import { projectNew, clearNewProject } from "../project/project.action";
import { steps } from "./constant";
import { setFilters } from "../../companies/companyMain/companyMain.action";
import { projectStagesTemplatesGet } from "modules/projects/newProject/stepOne/stepOne.actions";
import { ModalBody, ModalFooter } from "application/modal";

const NewProjectFordComponent = ({ popup }) => {
  const [CurrentStep, setCurrentStep] = useState(steps.step_one);
  const formRef = useRef();
  const dispatch = useDispatch();
  const history = useHistory();
  const [newProject, setNewProject] = useState({});
  const [nextButton, setNextButton] = useState("Next");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [selectedMembers, setSelectedMembers] = useState([]);
  const { enqueueSnackbar } = useSnackbar();

  const {
    councilReducer: { selectedCouncil },
    projectsReducer: {
      projectReducer: { newProjectObject },
    },
    stepOneReducer: { stageTemplates },
  } = useSelector((state) => state);

  useEffect(() => {
    if (!stageTemplates?.length && selectedCouncil) {
      dispatch(
        projectStagesTemplatesGet({
          council_id: selectedCouncil.id,
          enqueueSnackbar,
        })
      );
    }
  }, [selectedCouncil, stageTemplates]);

  useEffect(() => {
    localStorage.removeItem("new_project");
  }, []);

  useEffect(
    () => () => {
      localStorage.removeItem("new_project");
      localStorage.removeItem("new_project_object");
      dispatch(clearNewProject());
      dispatch(
        setFilters({
          topic_ids: [],
          industry_ids: [],
          disease_ids: [],
          country_ids: [],
        })
      );
    },
    []
  );

  useEffect(() => {
    if (newProjectObject) {
      const projObj = JSON.parse(localStorage.getItem("new_project_object"));

      history.push(`/projects/${projObj && projObj.id}/task?tab=all_task`);

      if (projObj.redirect_approval_task_id) {
        history.push(
          `/projects/${projObj.id}/task?tab=all_task&taskId=${projObj.redirect_approval_task_id}&gatewayTask=true`
        );
      } else {
        history.push(`/projects/${projObj && projObj.id}/task?tab=all_task`);
      }

      if (popup) {
        popup.hide();
      }
    }
  }, [newProjectObject]);

  window.onbeforeunload = function (e) {
    localStorage.removeItem("new_project");
    localStorage.removeItem("new_project_object");
    dispatch(clearNewProject());
    dispatch(
      setFilters({
        topic_ids: [],
        industry_ids: [],
        disease_ids: [],
        country_ids: [],
      })
    );
  };

  const handleBackClick = () => {
    if (CurrentStep !== steps.step_one) {
      setCurrentStep((prev) => prev - 1);
      setNextButton("Next");
    }
  };

  const makeEuropeMFGPayload = (values) => {
    const pattern = /-/;
    const customFieldProps = {};
    const simpleFields = {};

    Object.keys(values).forEach((key) => {
      // is custom field
      if (pattern.test(key)) {
        customFieldProps[key] = values[key];
      } else {
        simpleFields[key] = values[key];
      }
    });

    const getPossibleReplications = () => {
      if (!simpleFields.possible_replications) {
        return [];
      }

      return simpleFields.possible_replications.map((replication) => ({
        state: replication.state,
        plant_id: replication.id,
        areas_id: replication.areas.map((area) => area.id),
      }));
    };

    return {
      ford_custom_stuff: {
        instruction: simpleFields.instruction,
        project_id: values.isReplication ? simpleFields.project_id || "" : null,
        possible_replications: getPossibleReplications(),
        plant_id: simpleFields.selectedPlant?.id,
        area_ids:
          simpleFields.selectedPlant?.selectedAreas?.map(
            (area) => area.area_id
          ) || [],
        themes: simpleFields.themes?.map((t) => t.id) || [],
        next_stage_change: simpleFields.next_stage_change?.date || "",
        investment: simpleFields.investment,
        project_stage: simpleFields.project_stage,
        custom_project_fields: [
          {
            field_name: "Skills Team (Implementation)",
            field_value:
              simpleFields.skills_team?.map((el) => el?.value || el) || [],
          },
          {
            field_name: "Where did this Idea come from?",
            field_value:
              simpleFields.where_did_this_idea_come_from?.map(
                (el) => el?.value || el
              ) || [],
          },
          {
            field_name: "Problem Statement",
            field_value: simpleFields.problem_statement,
          },
          {
            field_name: "Potential Benefits",
            field_value: simpleFields.potential_benefits,
          },
          {
            field_name: "FPS Category",
            field_value:
              simpleFields.fps_category?.map((el) => el?.value || el) || [],
          },
        ],
      },
    };
  };

  const isEuropeMFG = useCallback(
    (values) => {
      const getStage = stageTemplates?.find(
        (s) =>
          s.id === (values?.stage_template_id?.val || values?.stage_template_id)
      );
      return (
        getStage?.name === "Europe MFG Innovation" ||
        getStage?.name === "US MFG Innovation"
      );
    },
    [stageTemplates]
  );

  const handleNextClick = () => {
    if (formRef.current) {
      formRef.current.handleSubmit();
    }

    if (formRef.current && !formRef.current?.isValid) return;

    const selectedPlant = formRef?.current?.values?.selectedPlant;

    if (
      selectedPlant?.id?.length > 0 &&
      selectedPlant.areas?.length > 0 &&
      !selectedPlant?.selectedAreas?.length
    ) {
      return false;
    }

    if (CurrentStep !== steps.step_three) {
      setCurrentStep((prev) => prev + 1);
    }

    if (CurrentStep === steps.step_two) {
      setNextButton("Done");
    }

    if (CurrentStep === steps.step_three) {
      let finalPayload = {};
      const getProject = JSON.parse(localStorage.getItem("new_project"));

      const isItEuropeTemplate = isEuropeMFG(getProject);

      if (isItEuropeTemplate) {
        const fordPayload = makeEuropeMFGPayload(getProject);
        finalPayload = {
          ...fordPayload,
          ...getProject,
          similar_projects: getProject.similar_projects?.map((p) => ({
            related_project_id: p.id,
          })),
          project_owners: getProject.project_owners?.map(
            (o) => o.user_id || o.id
          ),
        };
      } else {
        finalPayload = getProject;
      }

      setIsSubmitted(true);
      dispatch(projectNew({ enqueueSnackbar, ...finalPayload }));
    }
  };

  const moveNextStep = (step, value) => {
    const new_project = localStorage.getItem("new_project");
    if (!new_project) {
      localStorage.setItem("new_project", JSON.stringify(value));
    } else {
      let obj = JSON.parse(new_project);
      obj = { ...obj, value };
      localStorage.setItem("new_project", JSON.stringify(obj));
      setNewProject(obj);
    }
    setCurrentStep(step);
  };

  const getStepWindow = useCallback(() => {
    switch (CurrentStep) {
      case steps.step_one:
        return (
          <StepOneComponent
            formRef={formRef}
            moveNextStep={moveNextStep}
            defaultModel={newProject}
          />
        );
      case steps.step_two:
        return <StepTwoComponent />;
      case steps.step_three:
        return (
          <StepFiveComponent
            selectedMembers={selectedMembers}
            setSelectedMembers={setSelectedMembers}
          />
        );

      default:
        break;
    }
  }, [
    CurrentStep,
    newProject,
    moveNextStep,
    formRef,
    setSelectedMembers,
    selectedMembers,
  ]);

  const checkSubmitBtnIsDisabled = useMemo(() => {
    if (!formRef?.current) return false;

    const values = formRef.current.values;
    const getStage = stageTemplates?.find(
      (s) =>
        s.id === (values?.stage_template_id?.val || values?.stage_template_id)
    );

    if (
      getStage?.name !== "Europe MFG Innovation" &&
      getStage?.name !== "US MFG Innovation"
    )
      return false;

    if (values) {
      return values.selectedPlant && values.selectedPlant?.areas?.length
        ? values.selectedPlant?.selectedAreas?.length === 0
        : false;
    }

    return false;
  }, [formRef, stageTemplates]);

  return (
    <div>
      <ModalBody>
        <div className={styles.wrapper}>
          <div className={styles.container}>
            {isSubmitted && (
              <div className="col-md-6">
                <h3>
                  Please wait a moment as we pull everything together to create
                  your project
                </h3>
              </div>
            )}
            {!isSubmitted && (
              <div className="col-md-6">
                <div className={styles.captionStyle}>
                  Step
                  {" " + CurrentStep} of 3
                </div>
                <div style={{ height: "80vh" }}>{getStepWindow()}</div>
              </div>
            )}
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        {!isSubmitted && (
          <div className={styles.btnWrap}>
            <div className={styles.btnBack}>
              {CurrentStep === steps.step_one ? (
                <Button btn={BtnType.FRAME_LESS} onClick={() => popup.hide()}>
                  Close
                </Button>
              ) : (
                <Button btn={BtnType.FRAME_LESS} onClick={handleBackClick}>
                  Back
                </Button>
              )}
            </div>
            <div className={styles.btnNext}>
              {CurrentStep !== steps.step_three &&
                CurrentStep !== steps.step_one && (
                  <Button
                    btn={BtnType.FRAME_LESS}
                    className={styles.skipButton}
                    onClick={handleNextClick}
                  >
                    Skip
                  </Button>
                )}
              <Button
                btn={BtnType.REGULAR}
                className="ml-2"
                onClick={handleNextClick}
                disabled={checkSubmitBtnIsDisabled}
              >
                {nextButton}
              </Button>
            </div>
          </div>
        )}
      </ModalFooter>
    </div>
  );
};

export default React.memo(NewProjectFordComponent);
